import { TableContainer, variables } from '@hopskipdrive/react-components';
import styled from 'styled-components';

export const Container = styled(TableContainer)<{ minHeight?: string; minWidth: string }>`
  height: auto;
  min-height: ${(props) => props.minHeight || 'auto'};
  overflow: initial;

  thead {
    th {
      top: 0px;
      padding: 16px 24px 16px 16px;
      border-bottom: 1px solid ${variables.color.neutralvariant90};
    }
  }
  tbody {
    td {
      border-bottom: 1px solid ${variables.color.neutralvariant90};
    }
  }

  ${(props) =>
    props.minWidth &&
    `@media (max-width: ${props.minWidth}) {
      overflow: auto;
      thead {
        th {
          border-bottom: 1px solid ${variables.color.neutralvariant90};
          top: 0;
        }
      }
      tbody {
        td {
          border-bottom: 1px solid ${variables.color.neutralvariant90};
        }
        tr {
          height: 10px;
        }

        tr td {
          height: auto !important;
        }
      }
    }`}
`;
